import React from 'react'
import { LazyLoadComponent } from 'react-lazy-load-image-component'
import styled from 'styled-components'
import { Link } from 'gatsby'

import { MysqlRanks } from '../../../graphqlTypes'

const Container = styled.li`
  margin: 22px 0 0;
  padding: 0 3px;
  width: 50%;
  &:first-child {
    margin: 0 auto;
    padding: 0 6px;
    width: 100%;
  }
`

const EmblemContainer = styled.figure`
  width: 72px;
  height: 72px;
`

const EmblemImage = styled.img`
  width: 100%;
  height: 100%;
`

const ImageFrame = styled(Link)`
  display: block;
  width: 100%;
  height: 160px;
  margin: 12px auto 0;
  text-align: center;
  text-decoration: none;
`

const Image = styled.img`
  object-fit: contain;
  max-width: 160px;
  max-height: 160px;
`

const TextInfo = styled.div`
  color: ${({ theme }) => theme.palette.font.main};
  font-weight: bold;
  margin: 10px 0 0;
  &:first-child {
    margin: 13px 0 0;
  }
`

const Manufacturer = styled.p`
  font-size: 10px;
  margin: 0 0 4px;
`

const ProductName = styled.p`
  font-size: 10px;
`

type Props = {
  rank: MysqlRanks
}

export default function AwardItem({ rank }: Props) {
  const product = rank.products!

  return (
    <Container>
      <EmblemContainer>
        <EmblemImage
          alt={'ママリ口コミ大賞 入賞エンブレム画像'}
          src={`${product.fields!.emblemImageUrl}?auto=format&w=144&h=144`}
          decoding={'async'}
        />
      </EmblemContainer>
      <ImageFrame to={product.fields!.pagePath!}>
        <LazyLoadComponent>
          <Image
            alt={product.name!}
            src={`${product.fields!.imageUrl}?auto=format&fit=clip&w=320&h=320`}
            decoding={'async'}
          />
        </LazyLoadComponent>
      </ImageFrame>
      <TextInfo>
        {product.manufacturer && <Manufacturer>{product.manufacturer}</Manufacturer>}
        <ProductName>{product.name}</ProductName>
      </TextInfo>
    </Container>
  )
}
